import { ChartPercentiles } from "./chartPercentiles";
import { ChartStat } from "./chartStat";

export class ChartData {
    public dataPoints: ChartStat[] = [];
    public spendPercentiles: ChartPercentiles = new ChartPercentiles();
}